// import React, { useContext, useEffect } from 'react'
// import images from '../../utils/images'
// import CardWithText from '../../components/Cards/CardWithText'
// import employerContext from '../../hooks/employerContext'
// import Cookies from 'js-cookie'
// import { useNavigate } from 'react-router-dom'

// const EmployerPricing = () => {
//   const navigate = useNavigate();

//   const { country,
//     is_trial_started,
//     countryLoading,
//     checkOutStatus,
//     subscriptionExpiredShow,
//     updateCheckoutStatus,
//     pricingResponse,
//     subscription_going_to_end } = useContext(employerContext)

//   const freeTierData = [
//     "Explore the platform at no cost",
//     "Set up your company profile to increase visibility",
//     "Understand the features before upgrading",
//   ]

//   const basic_data = [
//     "No of users",
//     "Unlimited Access to candidate pool",
//     "Cost per additional listing",
//     "AI Powered Candidate Recommendation",
//     "Unlimited Listings",
//     "No Success fee"
//   ]

//   const premium_data = [
//     "No of users",
//     "Unlimited Access to candidate pool",
//     "Cost per additional listing",
//     "AI Powered Candidate Recommendation",
//     "Unlimited Listings",
//     "Personalised recommendation from 2nd Careers team from the applicant pool",
//     "Display Priority",
//     "No Success fee"
//   ]

//   const platinum_data = [
//     "No of users",
//     "Unlimited Access to candidate pool",
//     "Cost per additional listing",
//     "AI Powered Candidate Recommendation",
//     "Unlimited Listings",
//     "Personalised recommendation from 2nd Careers team from applicant pool",
//     "Display Priority",
//     "Assessment Report",
//     "Dedicated Account Manager",
//     "Success fees",

//   ]

//   useEffect(() => {
//     if (Cookies.get("user_role") && !["employer", "employer_sub_admin"]?.includes(Cookies.get("user_role"))) {
//       navigate("/employer_dashboard/home")
//     } else {
//       updateCheckoutStatus()
//     }
//   }, []);

//   return (
//     <>
//       <div className="pricing-plan">
//         <section className="pt-5">
//           <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4 col-12 co-sm-9 col-lg-10 mx-auto pt-3">
//             <div className="w-100 text-center mt-4">
//               <span className="fs-3 fw-bold">Pricing plan</span>
//               <span className="ms-4 d-block">
//                 <img
//                   src={images.underline}
//                   alt="underline"
//                   className="img-responsive logo"
//                 />
//               </span>
//             </div>

//             <div className="col">
//               <CardWithText
//                 cardTitle="Free"
//                 countryLoading={countryLoading}
//                 cardContent_1="Yes"
//                 cardContent_2="Yes"
//                 cardContent_3="Yes"
//                 cardBtnName="Get Free trial"
//                 planPhase="Employer"
//                 plan="Free"
//                 pricingPlan={checkOutStatus.productPlan}
//                 planKey={country === "India" ? process.env.REACT_APP_EMPLOYER_BASIC : process.env.REACT_APP_EMPLOYER_BASIC_US}
//                 currentPlan={checkOutStatus.paymentStatus === "trialing" && checkOutStatus.productPlan === "Basic"}
//                 checkOutStatus={checkOutStatus}
//                 questionArray={freeTierData}
//                 subscriptionExpiredShow={subscriptionExpiredShow}
//                 is_trial_started={is_trial_started}
//                 pricingResponse={pricingResponse}
//                 recallFun={() => updateCheckoutStatus()}
//                 subscription_going_to_end={subscription_going_to_end}
//               />
//             </div>

//             <div className="col">
//               <CardWithText
//                 cardTitle="Basic"
//                 cardPrice={country === "India" ? process.env.REACT_APP_EMPLOYER_BASIC_RUPEES : `$${process.env.REACT_APP_EMPLOYER_BASIC_DOLLARS}`}
//                 countryLoading={countryLoading}
//                 cardContent_1="1 user"
//                 cardContent_2="Yes"
//                 cardContent_3={country === "India" ? process.env.REACT_APP_ADDITIONAL_JOB_BASIC_RUPEES : '$' + process.env.REACT_APP_ADDITIONAL_JOB_BASIC_DOLLARS}
//                 cardContent_4=""
//                 cardContent_5="2 concurrent positions anytime during the subscription period."
//                 cardContent_6=""
//                 cardBtnName="Checkout"
//                 planPhase="Employer"
//                 plan="Basic"
//                 pricingPlan={checkOutStatus.productPlan}
//                 planKey={country === "India" ? process.env.REACT_APP_EMPLOYER_BASIC : process.env.REACT_APP_EMPLOYER_BASIC_US}
//                 currentPlan={(checkOutStatus.paymentStatus === "active" || checkOutStatus.paymentStatus === "paid") && checkOutStatus.productPlan === "Basic"}
//                 checkOutStatus={checkOutStatus}
//                 questionArray={basic_data}
//                 subscriptionExpiredShow={subscriptionExpiredShow}
//                 is_trial_started={is_trial_started}
//                 pricingResponse={pricingResponse}
//                 recallFun={() => updateCheckoutStatus()}
//                 subscription_going_to_end={subscription_going_to_end}
//               />
//             </div>

//             <div className="col">
//               <CardWithText
//                 cardTitle="Premium"
//                 cardPrice={country === "India" ? process.env.REACT_APP_EMPLOYER_PREMIUM_RUPEES : `$${process.env.REACT_APP_EMPLOYER_PREMIUM_DOLLARS}`}
//                 countryLoading={countryLoading}
//                 cardContent_1="2 users"
//                 cardContent_2="Yes"
//                 cardContent_3={country === "India" ? process.env.REACT_APP_ADDITIONAL_JOB_PREMIUM_RUPEES : '$' + process.env.REACT_APP_ADDITIONAL_JOB_PREMIUM_DOLLARS}
//                 cardContent_4=""
//                 cardContent_5="5 concurrent positions anytime during the subscription period."
//                 cardContent_6=""
//                 cardContent_7="Yes"
//                 cardContent_8=""
//                 cardBtnName="Checkout"
//                 planPhase="Employer"
//                 plan="Premium"
//                 pricingPlan={checkOutStatus.productPlan}
//                 planKey={country === "India" ? process.env.REACT_APP_EMPLOYER_PREMIUM : process.env.REACT_APP_EMPLOYER_PREMIUM_US}
//                 currentPlan={(checkOutStatus.paymentStatus === "active" || checkOutStatus.paymentStatus === "paid") && checkOutStatus.productPlan === "Premium"}
//                 checkOutStatus={checkOutStatus}
//                 questionArray={premium_data}
//                 subscriptionExpiredShow={subscriptionExpiredShow}
//                 is_trial_started={is_trial_started}
//                 pricingResponse={pricingResponse}
//                 recallFun={() => updateCheckoutStatus()}
//                 subscription_going_to_end={subscription_going_to_end}
//               />
//             </div>

//             <div className="col">
//               <CardWithText
//                 cardTitle="Platinum"
//                 cardPrice={country === "India" ? process.env.REACT_APP_EMPLOYER_PLATINUM_RUPEES : `$${process.env.REACT_APP_EMPLOYER_PLATINUM_DOLLARS}`}
//                 countryLoading={countryLoading}
//                 cardContent_1="5 users"
//                 cardContent_2="Yes"
//                 cardContent_3="Additional listing at Custom pricing "
//                 cardContent_4=""
//                 cardContent_5="10 concurrent positions anytime during the subscription period."
//                 cardContent_6=""
//                 cardContent_7="Yes"
//                 cardContent_8="Personalized assessments and interview reports for candidates shortlised for any two job listings"
//                 cardContent_9="Yes"
//                 cardContent_10="5% of annual CTC off platform services"
//                 cardBtnName="Checkout"
//                 planPhase="Employer"
//                 plan="Platinum"
//                 pricingPlan={checkOutStatus.productPlan}
//                 planKey={country === "India" ? process.env.REACT_APP_EMPLOYER_PLATINUM : process.env.REACT_APP_EMPLOYER_PLATINUM_US}
//                 currentPlan={(checkOutStatus.paymentStatus === "active" || checkOutStatus.paymentStatus === "paid") && checkOutStatus.productPlan === "Platinum"}
//                 checkOutStatus={checkOutStatus}
//                 questionArray={platinum_data}
//                 subscriptionExpiredShow={subscriptionExpiredShow}
//                 is_trial_started={is_trial_started}
//                 pricingResponse={pricingResponse}
//                 recallFun={() => updateCheckoutStatus()}
//                 subscription_going_to_end={subscription_going_to_end}
//               />
//             </div>

//             <div className="text-center w-100 fw-medium cardCopyRight mt-5">
//               <span className="d-block mb-1">
//                 Copyright &copy; 2024 | Powered by 2nd Careers
//               </span>
//               <span className="d-block mb-3"><span className="cursorPointer" onClick={() => window.open("https://2ndcareers.com/terms-and-conditions/", "_blank")}>Terms&nbsp;and&nbsp;conditions
//               </span> | <span className="cursorPointer" onClick={() => window.open("https://2ndcareers.com/privacy-policy/", "_blank")}>Privacy policy</span></span>
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   )
// }

// export default EmployerPricing


import React, { useContext, useEffect } from 'react'
import images from '../../utils/images'
import CardWithText from '../../components/Cards/CardWithText'
import employerContext from '../../hooks/employerContext'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'

const EmployerPricing = () => {
  const navigate = useNavigate();

  const { country,
    is_trial_started,
    countryLoading,
    checkOutStatus,
    subscriptionExpiredShow,
    updateCheckoutStatus,
    pricingResponse,
    subscription_going_to_end } = useContext(employerContext)

  const freeTierData = [
    "Explore the platform at no cost",
    "Set up your company profile to increase visibility",
    "Understand the features before upgrading",
  ]

  const basic_data = [
    "No of users",
    "Access to candidate pool",
    "Listings (45 days each)",
    "Concurrent Listings",
    "Cost per additional concurrent listing",
    "AI Powered Recommendation",
    "Success fee",
    "Job Display Priority",
    "2nd Careers Team Provides Personalized Recommendations",
    "Dedicated Account Manager",
    "Personalized assessment and interview reports for candidates shortlisted for any two job listings"
  ]

  const premium_data = [
    "No of users",
    "Access to candidate pool",
    "Listings (45 days each)",
    "Concurrent Listings",
    "Cost per additional concurrent listing",
    "AI Powered Recommendation",
    "Success fee",
    "Job Display Priority",
    "2nd Careers Team Provides Personalized Recommendations",
    "Dedicated Account Manager",
    "Personalized assessment and interview reports for candidates shortlisted for any two job listings"
  ]

  const platinum_data = [
    "No of users",
    "Access to candidate pool",
    "Listings (45 days each)",
    "Concurrent Listings",
    "Cost per additional concurrent listing",
    "AI Powered Recommendation",
    "Success fee",
    "Job Display Priority",
    "2nd Careers Team Provides Personalized Recommendations",
    "Dedicated Account Manager",
    "Personalized assessment and interview reports for candidates shortlisted for any two job listings"
  ]

  useEffect(() => {
    if (Cookies.get("user_role") && !["employer", "employer_sub_admin"]?.includes(Cookies.get("user_role"))) {
      navigate("/employer_dashboard/home")
    } else {
      updateCheckoutStatus()
    }
  }, []);

  return (
    <>
      <div className="pricing-plan">
        <section className="pt-5">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4 col-12 co-sm-9 col-lg-10 mx-auto pt-3">
            <div className="w-100 text-center mt-4">
              <span className="fs-3 fw-bold">Pricing plan</span>
              <span className="ms-4 d-block">
                <img
                  src={images.underline}
                  alt="underline"
                  className="img-responsive logo"
                />
              </span>
            </div>

            <div className="col">
              <CardWithText
                cardTitle="Free"
                countryLoading={countryLoading}
                cardContent_1="Yes"
                cardContent_2="Yes"
                cardContent_3="Yes"
                cardBtnName="Get Free trial"
                planPhase="Employer"
                plan="Free"
                pricingPlan={checkOutStatus.productPlan}
                planKey={country === "India" ? process.env.REACT_APP_EMPLOYER_BASIC : process.env.REACT_APP_EMPLOYER_BASIC_US}
                currentPlan={checkOutStatus.paymentStatus === "trialing" && checkOutStatus.productPlan === "Basic"}
                checkOutStatus={checkOutStatus}
                questionArray={freeTierData}
                subscriptionExpiredShow={subscriptionExpiredShow}
                is_trial_started={is_trial_started}
                pricingResponse={pricingResponse}
                recallFun={() => updateCheckoutStatus()}
                subscription_going_to_end={subscription_going_to_end}
              />
            </div>

            <div className="col">
              <CardWithText
                cardTitle="Basic"
                country={country}
                cardPrice={country === "India" ? process.env.REACT_APP_EMPLOYER_BASIC_RUPEES : `$${process.env.REACT_APP_EMPLOYER_BASIC_DOLLARS}`}
                countryLoading={countryLoading}
                cardContent_1="1"
                cardContent_2="Unlimited"
                cardContent_3="Unlimited"
                cardContent_4="2"
                cardContent_5={
                  <span>
                    {country === "India" ? process.env.REACT_APP_ADDITIONAL_JOB_BASIC_RUPEES : '$' + process.env.REACT_APP_ADDITIONAL_JOB_BASIC_DOLLARS}
                    <span style={{ verticalAlign: 'top', display: country === "India" ? '' : 'none' }}>*</span>
                  </span>
                }
                cardContent_6="Yes"
                cardContent_7="No"
                cardContent_8="No"
                cardContent_9="No"
                cardContent_10="No"
                cardContent_11="No"
                cardBtnName="Checkout"
                planPhase="Employer"
                plan="Basic"
                pricingPlan={checkOutStatus.productPlan}
                planKey={country === "India" ? process.env.REACT_APP_EMPLOYER_BASIC : process.env.REACT_APP_EMPLOYER_BASIC_US}
                currentPlan={(checkOutStatus.paymentStatus === "active" || checkOutStatus.paymentStatus === "paid") && checkOutStatus.productPlan === "Basic"}
                checkOutStatus={checkOutStatus}
                questionArray={basic_data}
                subscriptionExpiredShow={subscriptionExpiredShow}
                is_trial_started={is_trial_started}
                pricingResponse={pricingResponse}
                recallFun={() => updateCheckoutStatus()}
                subscription_going_to_end={subscription_going_to_end}
              />
            </div>

            <div className="col">
              <CardWithText
                country={country}
                cardTitle="Premium"
                cardPrice={country === "India" ? process.env.REACT_APP_EMPLOYER_PREMIUM_RUPEES : `$${process.env.REACT_APP_EMPLOYER_PREMIUM_DOLLARS}`}
                countryLoading={countryLoading}
                cardContent_1="2"
                cardContent_2="Unlimited"
                cardContent_3="Unlimited"
                cardContent_4="5"
                cardContent_5={
                  <span>
                    {country === "India" ? process.env.REACT_APP_ADDITIONAL_JOB_PREMIUM_RUPEES : '$' + process.env.REACT_APP_ADDITIONAL_JOB_PREMIUM_DOLLARS}
                    <span style={{ verticalAlign: 'top', display: country === "India" ? '' : 'none' }}>*</span>
                  </span>
                }
                cardContent_6="Yes"
                cardContent_7="No"
                cardContent_8="Yes"
                cardContent_9="Yes"
                cardContent_10="No"
                cardContent_11="No"
                cardBtnName="Checkout"
                planPhase="Employer"
                plan="Premium"
                pricingPlan={checkOutStatus.productPlan}
                planKey={country === "India" ? process.env.REACT_APP_EMPLOYER_PREMIUM : process.env.REACT_APP_EMPLOYER_PREMIUM_US}
                currentPlan={(checkOutStatus.paymentStatus === "active" || checkOutStatus.paymentStatus === "paid") && checkOutStatus.productPlan === "Premium"}
                checkOutStatus={checkOutStatus}
                questionArray={premium_data}
                subscriptionExpiredShow={subscriptionExpiredShow}
                is_trial_started={is_trial_started}
                pricingResponse={pricingResponse}
                recallFun={() => updateCheckoutStatus()}
                subscription_going_to_end={subscription_going_to_end}
              />
            </div>

            <div className="col">
              <CardWithText
                country={country}
                cardTitle="Platinum"
                cardPrice={country === "India" ? process.env.REACT_APP_EMPLOYER_PLATINUM_RUPEES : `$${process.env.REACT_APP_EMPLOYER_PLATINUM_DOLLARS}`}
                countryLoading={countryLoading}
                cardContent_1="5"
                cardContent_2="Unlimited"
                cardContent_3="Unlimited"
                cardContent_4="10"
                cardContent_5={
                  <span>
                    Custom pricing
                    <span style={{ verticalAlign: 'top', display: country === "India" ? '' : 'none' }}>*</span>
                  </span>
                }
                cardContent_6="Yes"
                cardContent_7={
                  <span>
                    5% of annual CTC off platform services
                    <span style={{ verticalAlign: 'top', display: country === "India" ? '' : 'none' }}>*</span>
                  </span>
                }
                cardContent_8="Yes"
                cardContent_9="Yes"
                cardContent_10="Yes"
                cardContent_11="Yes"
                cardBtnName="Checkout"
                planPhase="Employer"
                plan="Platinum"
                pricingPlan={checkOutStatus.productPlan}
                planKey={country === "India" ? process.env.REACT_APP_EMPLOYER_PLATINUM : process.env.REACT_APP_EMPLOYER_PLATINUM_US}
                currentPlan={(checkOutStatus.paymentStatus === "active" || checkOutStatus.paymentStatus === "paid") && checkOutStatus.productPlan === "Platinum"}
                checkOutStatus={checkOutStatus}
                questionArray={platinum_data}
                subscriptionExpiredShow={subscriptionExpiredShow}
                is_trial_started={is_trial_started}
                pricingResponse={pricingResponse}
                recallFun={() => updateCheckoutStatus()}
                subscription_going_to_end={subscription_going_to_end}
              />
            </div>

            {
              country === "India" && !countryLoading && <p className="text-center mt-3">
                <span className="text-danger">*</span>
                Taxes will be additional
              </p>
            }

            <div className="text-center w-100 fw-medium cardCopyRight mt-5">
              <span className="d-block mb-1">
                Copyright &copy; 2024 | Powered by 2nd Careers
              </span>
              <span className="d-block mb-3"><span className="cursorPointer" onClick={() => window.open("https://2ndcareers.com/terms-and-conditions/", "_blank")}>Terms&nbsp;and&nbsp;conditions
              </span> | <span className="cursorPointer" onClick={() => window.open("https://2ndcareers.com/privacy-policy/", "_blank")}>Privacy policy</span></span>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default EmployerPricing